var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-flex',[_c('application-details',{attrs:{"application":_vm.application,"title":_vm.title,"subtitle":_vm.subtitle,"application-state-text":_vm.applicationStateText,"new-card-application":_vm.newCardApplication}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }